<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M8.5 14.5C8.36739 14.5 8.24021 14.4473 8.14645 14.3536C8.05268 14.2598 8 14.1326 8 14C8 13.8674 8.05268 13.7402 8.14645 13.6464C8.24021 13.5527 8.36739 13.5 8.5 13.5H15.5C15.6326 13.5 15.7598 13.5527 15.8536 13.6464C15.9473 13.7402 16 13.8674 16 14C16 14.1326 15.9473 14.2598 15.8536 14.3536C15.7598 14.4473 15.6326 14.5 15.5 14.5H8.5ZM8.5 17C8.36739 17 8.24021 16.9473 8.14645 16.8536C8.05268 16.7598 8 16.6326 8 16.5C8 16.3674 8.05268 16.2402 8.14645 16.1464C8.24021 16.0527 8.36739 16 8.5 16H15.5C15.6326 16 15.7598 16.0527 15.8536 16.1464C15.9473 16.2402 16 16.3674 16 16.5C16 16.6326 15.9473 16.7598 15.8536 16.8536C15.7598 16.9473 15.6326 17 15.5 17H8.5Z"
      :class="containerClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.185 3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V19.5C5 19.8978 5.15804 20.2794 5.43934 20.5607C5.72064 20.842 6.10218 21 6.5 21H17.5C17.8978 21 18.2794 20.842 18.5607 20.5607C18.842 20.2794 19 19.8978 19 19.5V9.202C18.9999 8.82647 18.859 8.46464 18.605 8.188L14.291 3.486C14.1504 3.33275 13.9795 3.2104 13.7891 3.12673C13.5987 3.04307 13.393 2.99991 13.185 3ZM6 4.5C6 4.36739 6.05268 4.24022 6.14645 4.14645C6.24021 4.05268 6.36739 4 6.5 4H13.185C13.2544 3.99992 13.323 4.01429 13.3865 4.04218C13.4501 4.07007 13.5071 4.11087 13.554 4.162L17.868 8.864C17.9528 8.95616 17.9999 9.07678 18 9.202V19.5C18 19.6326 17.9473 19.7598 17.8536 19.8536C17.7598 19.9473 17.6326 20 17.5 20H6.5C6.36739 20 6.24021 19.9473 6.14645 19.8536C6.05268 19.7598 6 19.6326 6 19.5V4.5Z"
      :class="containerClass"
    />
    <path d="M13.5 4.1001V8.8001H18.2" stroke-linecap="round" stroke-linejoin="round" :class="containerClass" />
    <path
      d="M10.134 8.13301C10.2768 8.13739 10.419 8.11304 10.5523 8.06141C10.6855 8.00978 10.807 7.93192 10.9095 7.83246C11.0121 7.73299 11.0936 7.61394 11.1493 7.48237C11.205 7.3508 11.2337 7.20938 11.2337 7.06651C11.2337 6.92364 11.205 6.78223 11.1493 6.65066C11.0936 6.51908 11.0121 6.40003 10.9095 6.30057C10.807 6.2011 10.6855 6.12325 10.5523 6.07162C10.419 6.01999 10.2768 5.99564 10.134 6.00001C9.85681 6.0085 9.5938 6.12458 9.40073 6.32367C9.20765 6.52275 9.09967 6.78918 9.09967 7.06651C9.09967 7.34384 9.20765 7.61028 9.40073 7.80936C9.5938 8.00844 9.85681 8.12452 10.134 8.13301Z"
      :class="containerClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.266 10.444C12.266 9.31001 11.311 8.48901 10.133 8.48901C8.955 8.48901 8 9.30901 8 10.444V10.978C8.00026 11.0723 8.03789 11.1626 8.10462 11.2291C8.17136 11.2956 8.26176 11.333 8.356 11.333H11.911C12.0051 11.3327 12.0952 11.2953 12.1617 11.2287C12.2283 11.1622 12.2657 11.0721 12.266 10.978V10.444Z"
      :class="containerClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 23.5C18.351 23.5 23.5 18.351 23.5 12C23.5 5.649 18.351 0.5 12 0.5C5.649 0.5 0.5 5.649 0.5 12C0.5 18.351 5.649 23.5 12 23.5ZM12 24.5C18.904 24.5 24.5 18.904 24.5 12C24.5 5.096 18.904 -0.5 12 -0.5C5.096 -0.5 -0.5 5.096 -0.5 12C-0.5 18.904 5.096 24.5 12 24.5Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
